import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import UserManagement from './pages/UserManagement';
import VesselManagement from './pages/VesselManagement';
import SupplierVessels from './pages/SupplierVessels';
import VerifierVessels from './pages/VerifierVessels';
import Bunkerings from './pages/Bunkerings';
import UploadBunkering from './pages/UploadBunkering';
import BunkeringDetail from './pages/BunkeringDetail';
import DocumentDetails from './pages/DocumentDetails';
import ManagePermissions from './pages/ManagePermissions';
import ChangePassword from './pages/ChangePassword';
import ProfileUpdate from './pages/ProfileUpdate';
import { AuthContext, AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';

// App component configures application routes and renders Navbar when authenticated.
function AppContent() {
  const { user, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {user && <Navbar />}
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />

        <Route
          path="/users"
          element={
            <PrivateRoute roles={['ADMIN']}>
              <UserManagement />
            </PrivateRoute>
          }
        />

        <Route
          path="/vessels"
          element={
            <PrivateRoute roles={['SHIPOWNER']}>
              <VesselManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/permissions"
          element={
            <PrivateRoute roles={['SHIPOWNER']}>
              <ManagePermissions />
            </PrivateRoute>
          }
        />

        <Route
          path="/bunkerings"
          element={
            <PrivateRoute roles={['SHIPOWNER', 'SUPPLIER', 'VERIFIER']}>
              <Bunkerings />
            </PrivateRoute>
          }
        />
        <Route
          path="/bunkerings/new"
          element={
            <PrivateRoute roles={['SHIPOWNER', 'SUPPLIER']}>
              <UploadBunkering />
            </PrivateRoute>
          }
        />
        <Route
          path="/bunkerings/:id"
          element={
            <PrivateRoute roles={['SHIPOWNER', 'SUPPLIER', 'VERIFIER']}>
              <BunkeringDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/documents/:documentId"
          element={
            <PrivateRoute roles={['SHIPOWNER', 'SUPPLIER', 'VERIFIER']}>
              <DocumentDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/change-password"
          element={
            <PrivateRoute roles={['ADMIN', 'SHIPOWNER', 'SUPPLIER', 'VERIFIER']}>
              <ChangePassword />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute roles={['SHIPOWNER', 'SUPPLIER', 'VERIFIER']}>
              <ProfileUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/supplier-vessels"
          element={
            <PrivateRoute roles={['SUPPLIER']}>
              <SupplierVessels />
            </PrivateRoute>
          }
        />

        <Route
          path="/verifier-vessels"
          element={
            <PrivateRoute roles={['VERIFIER']}>
              <VerifierVessels />
            </PrivateRoute>
          }
        />

        <Route
          path="/"
          element={
            !user ? <Navigate to="/login" /> :
            user.role === 'ADMIN' ? <Navigate to="/users" /> :
            user.role === 'SHIPOWNER' ? <Navigate to="/vessels" /> :
            user.role === 'SUPPLIER' ? <Navigate to="/supplier-vessels" /> :
            user.role === 'VERIFIER' ? <Navigate to="/verifier-vessels" /> :
            <Navigate to="/bunkerings" />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CssBaseline />
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}
